import React from "react";
import CommunityEditPage from "../community/components/CommunityEditPage";
import { OTHER_REQUESTS } from "../community/constants";
import { useRequireSectionVisible } from "../../client/hooks/useRequireSectionVisible";

export default function EditOtherRequestsPage() {
  useRequireSectionVisible("showOtherRequests");
  return <CommunityEditPage section={OTHER_REQUESTS} />;
}
